import PropTypes from 'prop-types';
import ImageWithDefault from '../shared/ImageWithDefault';
import css from './profile-logo.module.scss';

const ProfileLogo = ({ image, title }) => (
  <div className={css.logoContainer}>
    <ImageWithDefault
      src={image}
      alt={`${title}-logo`}
      dataTestId="logo"
      className={css.logoImage}
    />
  </div>
);

ProfileLogo.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default ProfileLogo;
